import React from "react";
import AccountLayout from "../AccountLayout";
import { Container, Form, Row, Button, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const ForgetPassForm = () => {
  return (
    <>
      <AccountLayout>
        <div className="account-card px-4 py-4 bg-white">
          <div className="head-div mb-3">
            <h2 className="mb-0 pb-2 head">Forgot Password</h2>
          </div>
          <Form>
            <Row>
              <Col lg="12" className="my-3">
                <label className="form-label m-0">Your email</label>
                <Form.Control type="email" placeholder="Your email" />
              </Col>
              <Col lg="12" className="my-3 btn-wrap">
                <Link to="/" className="w-100 text-white submit-btn">
                  Send
                </Link>
              </Col>
            </Row>
          </Form>
        </div>
      </AccountLayout>
    </>
  );
};
export default ForgetPassForm;
